const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const api = {
  // Auth
  signup: async (data) => {
    const res = await fetch(`${API_URL}/api/auth/signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Signup failed');
    return res.json();
  },

  login: async (data) => {
    const res = await fetch(`${API_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Login failed');
    return res.json();
  },

  logout: async () => {
    const res = await fetch(`${API_URL}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Logout failed');
    return res.json();
  },

  getMe: async () => {
    const res = await fetch(`${API_URL}/api/auth/me`, {
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Not authenticated');
    return res.json();
  },
  updateProfile: async (data) => {
    const res = await fetch(`${API_URL}/api/auth/profile`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Failed to update profile');
    return res.json();
  },

  // Jobs
  getJobs: async (params = {}) => {
    const query = new URLSearchParams(params);
    const res = await fetch(`${API_URL}/api/job_openings?${query}`, {
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Failed to fetch jobs');
    return res.json();
  },

  getJob: async (id) => {
    const res = await fetch(`${API_URL}/api/job_openings/${id}`, {
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Job not found');
    return res.json();
  },

  createJob: async (data) => {
    const res = await fetch(`${API_URL}/api/job_openings`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Failed to create job');
    return res.json();
  },

  updateJob: async (id, data) => {
    const res = await fetch(`${API_URL}/api/job_openings/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Failed to update job');
    return res.json();
  },

  deleteJob: async (id) => {
    const res = await fetch(`${API_URL}/api/job_openings/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Failed to delete job');
    return res.json();
  },

  // Blogs
  getBlogs: async (params = {}) => {
    const query = new URLSearchParams(params);
    const res = await fetch(`${API_URL}/api/blogs?${query}`, {
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Failed to fetch blogs');
    return res.json();
  },

  getBlog: async (id) => {
    const res = await fetch(`${API_URL}/api/blogs/${id}`, {
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Blog not found');
    return res.json();
  },

  createBlog: async (data) => {
    const res = await fetch(`${API_URL}/api/blogs`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Failed to create blog');
    return res.json();
  },

  updateBlog: async (id, data) => {
    const res = await fetch(`${API_URL}/api/blogs/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Failed to update blog');
    return res.json();
  },

  deleteBlog: async (id) => {
    const res = await fetch(`${API_URL}/api/blogs/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Failed to delete blog');
    return res.json();
  },

  // Applications
  createApplication: async (data) => {
    const res = await fetch(`${API_URL}/api/applications`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Failed to submit application');
    return res.json();
  },

  getApplications: async (params = {}) => {
    const query = new URLSearchParams(params);
    const res = await fetch(`${API_URL}/api/applications?${query}`, {
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Failed to fetch applications');
    return res.json();
  },

  updateApplicationStatus: async (id, status) => {
    const res = await fetch(`${API_URL}/api/applications/${id}/status`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ status })
    });
    if (!res.ok) throw new Error('Failed to update status');
    return res.json();
  },

  // Job Alerts
  createJobAlert: async (data) => {
    const res = await fetch(`${API_URL}/api/job_alerts`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Failed to create job alert');
    return res.json();
  },

  // File Upload
  uploadResume: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await fetch(`${API_URL}/api/upload/resume`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    });
    if (!res.ok) throw new Error('File upload failed');
    return res.json();
  },
};